import React, { useState, useEffect } from 'react';
import CustomTable from '../../../../../customComponents/CustomTable';
import downloadIcon from './../../../../../../Assets/icons/download.svg';
import searchIcon from './../../../../../../Assets/icons/searchicon.svg';
import editIcon from './../../../../../../Assets/icons/Un-Checkbox.svg';
import './index.scss';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../../../../services/api/API'; // Adjust this import path based on your project structure
import ROUTES_NAVIGATION from '../../../../../../routes/routes';
import { IoMdClose } from 'react-icons/io';
import Loader from '../../../../../customComponents/CustomLoader';

const DesignationList = () => {
  const [designationData, setDesignationData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(true);
  const [ totalData, setTotalData ] = useState(0)
  const [totalActive, setTotalActive] = useState(0)
  const [ totalInactive, setTotalInactive ] = useState(0)

  const navigate = useNavigate();
  const token = localStorage.getItem("authToken");

 
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchDesignationData(newPage);
  };
  useEffect(() => {
    if (searchTerm === '') {
      fetchDesignationData({ searchText: '' });
    }
  }, [searchTerm]);

  const fetchDesignationData = async (page = 0, pageSize = 10) => {
    try {
      setLoading(true)
      const response = await axiosInstance.post('/designation/list', {
        orderBy: 'designation_id desc',
        page,
        pageSize,
        searchText:searchTerm
      }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }
      });

      const formattedData = response.data.data.data.map((item, index) => ({
        ...item,

        "Sr No.": index + 1,
        hierarchy_level: `level ${item.hierarchy_level}`
      }));

      const totalRecordsData = response?.data?.data?.totalRecords

      const totalCount = response?.data?.data?.total
      const totalAct = response?.data?.data?.total_active
      const totalInac = response?.data?.data?.total_inactive

      setTotalData(totalCount)
      setTotalActive(totalAct)
      setTotalInactive(totalInac)

      console.log(totalRecordsData, "RECORDS")
      setTotalRecords(totalRecordsData);

      setDesignationData(formattedData); 
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize)); 
    } catch (error) {
      console.error('Error fetching designation list:', error);
    }
    finally{
      setLoading(false)
    }
  };
  const handleSearchInputChange = (event) => {
    const serachvalue= event.target.value
    setSearchTerm(event.target.value);
    if(serachvalue===''){
      fetchDesignationData()
    }  
  };
  const clearSearchAndFetch = () => {
    setSearchTerm("");
  };
  const DESIGNATION_TABLE_HEADERS = [
    "Name",
    "Description",
    "Heirarchy",
    // "Parent Designation Name",
    "Status",
    "Action"
  ];

  const DESIGNATION_KEY_MAPPING = {
    "Name": "designation_name",
    "Description": "designation_desc",
    "Heirarchy": "hierarchy_level",
    "Parent Designation Name":"parent_designation_name",
    "Status": "status",
    "Action": [
      { type: "edit", icon: editIcon, label: "Edit" },
    ]
  };

  const handleEdit = (rowData) => {
    navigate(`${ROUTES_NAVIGATION.EDITDESIGNATION}`, { state: { data: rowData } });
  }
  const handleKeyPress = (e) => {
    console.log("keyname",e.key);
    
    if (e.key === 'Enter') {
      fetchDesignationData(0, 10, searchTerm); 
    }
  }

  return (
    <div>
    {loading ? ( 
      <Loader />
    ) : (
    <div>
      <div className='OnboardManagamentContainer row'>
        <div className='OnboardManagamentbuttonContainer col-xl-6 col-lg-12 mt-2 mb-2'>
          <h5>Designation Management</h5>
        </div>
        <div className='totalvaluescontainer col-xl-6 col-lg-12 mt-2 mb-2'>
          <div className='topleftdataContainer' style={{borderRight: "1px solid black"}}>
            <h5 className="listTopDataValueText" >{totalData} </h5>
            <h6>All Designations</h6>
          </div>
          <div className='topleftdataContainer' style={{borderRight: "1px solid black"}}>
            <h5 className="listTopDataValueText" >{totalActive} </h5>
            <h6>Active Designations</h6>
          </div>
          <div className='topleftdataContainer'>
            <h5 className="listTopDataValueText" >{totalInactive} </h5>
            <h6>Inactive Designations</h6>
          </div>
          <div>
            <button className='addcustomerbutton' onClick={() => navigate('/admin/manage-designation/designation/add-designation')}>
              Add Designation
            </button>
          </div>
        </div>
      </div>

      <div className='tableWrapper'>
        <div className='admin-list-container'>
          <div className='listsearchContainer'>
            <h5>Designation List</h5>
            <div className="searchinput-wrapper">
              <input
                type='text'
                className='searchinput'
                placeholder='Search By Name'
                value={searchTerm}
                onChange={handleSearchInputChange}
                onKeyPress={handleKeyPress}

              />
              {searchTerm ? (
              <IoMdClose
                  size={22}
                  className="searchinput-close-icon"
                  onClick={clearSearchAndFetch}
                />
              ) : (
                <img src={searchIcon} alt="Search" className="searchinput-icon" />
              )}
            </div>
          </div>
         
        </div>

        <CustomTable data={designationData} headers={DESIGNATION_TABLE_HEADERS} keyMapping={DESIGNATION_KEY_MAPPING}  itemsPerPage={10}
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
          onEdit={handleEdit} 
          totalRecords={totalRecords}
          />
       </div>
      </div>
      )}
  </div>
  );
};

export default DesignationList;
